import { useEffect, useState } from 'react';
import './Tasks.css';
import { getLeadsTasks } from '../../utilities/api/leads';
import { calculateDaysBetween } from '../../utilities/services/calculateDaysBetween';
import TasksItem from '../TasksItem/TasksItem';

export default function Tasks({user, section, taskList}) {
    const today = new Date()
    const warningDays = 3
    // const [tasks, setTasks] = useState(taskList)
    const [loading, setLoading] = useState(false)
    const [upcomingTasks, setUpcomingTasks] = useState([])
    const upcomingTasksQuantity = 20
    const [overdueTasks, setOverdueTasks] = useState([])
    const overdueTasksQuantity = 20
    const [completeTasks, setCompleteTasks] = useState([])
    const completeTasksQuantity = 20

    const getMyLeadsTasks = async (userID) => {
        setLoading(true)
        try {
            const data = await getLeadsTasks(userID)
            // setTasks(data)
            setCompleteTasks([])
            setUpcomingTasks([])
            setOverdueTasks([])
            data.forEach((task) => {
                if ((calculateDaysBetween(today, task.deadline) <= 0) && task.status !== 'complete') {
                    setOverdueTasks(prev => [...prev, task].sort((a, b) => new Date(a.deadline) - new Date(b.deadline)))
                } else if ((calculateDaysBetween(today, task.deadline) > 0)  && task.status !== 'complete') {
                    setUpcomingTasks(prev => [...prev, task].sort((a, b) => new Date(a.deadline) - new Date(b.deadline)))
                } else if (task.status === 'complete') {
                    setCompleteTasks(prev => [...prev, task].sort((a, b) => new Date(b.deadline) - new Date(a.deadline)))
                }
            })
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }
    
    useEffect(() => {
        section === 'leads' && getMyLeadsTasks(user._id)
        // eslint-disable-next-line
    },[])

    if (loading) {
        return (
            <div className='Tasks modal fade' id='tasksModal' data-bs-keyboard="true" aria-labelledby={`tasksHeader`}>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className='loading'>
                            <div className="spinner-border" role="status"></div>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
  return (
    <div className='Tasks modal fade' id='tasksModal' data-bs-keyboard="true" aria-labelledby={`tasksHeader`}>
        <div className='modal-dialog'>
            <div className='modal-content'>
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" fill="currentColor" className="bi bi-list-task" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM3 3H2v1h1z"/>
                                <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                <path fillRule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5zM2 7h1v1H2zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm1 .5H2v1h1z"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                Tasks
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                        <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='tasksBody'>
                    <div className='nav nav-tabs flex-row navigation' id="v-tab" role='tablist' aria-orientation="horizontal">
                        <button className="nav-link active" id='upcomingTasksTab' data-bs-toggle="tab" role="tab" aria-controls="upcomingTasks" aria-selected="true" data-bs-target="#upcomingTasks" type="button">
                            Upcoming
                        </button>
                        <button className="nav-link" id='overdueTasksTab' data-bs-toggle="tab" role="tab" aria-controls="overdueTasks" aria-selected="false" data-bs-target="#overdueTasks" type="button">
                            Overdue
                        </button>
                        <button className="nav-link" id='completedTasksTab' data-bs-toggle="tab" role="tab" aria-controls="completedTasks" aria-selected="false" data-bs-target="#completedTasks" type="button">
                            Completed
                        </button>
                    </div>
                    <div className='content tab-content' id="v-tabContent">
                        { section === 'leads' &&
                        <div className='header'>
                            <div className='taskOwner'>Lead</div>
                            <div className='taskTitle'>Task</div>
                            <div className='taskPriority'>Priority</div>
                            <div className='taskDeadline'>Deadline</div>
                            <div className='assignedTo'>Assigned To</div>
                        </div>
                        }
                        <div className="upcomingTasks tab-pane fade show active" id="upcomingTasks" role="tabpanel" aria-labelledby="upcomingTasksTab">
                            { upcomingTasks.length === 0 && 
                                <div className='noTasks'>No Upcoming Tasks</div>
                            }
                            { upcomingTasks.map((task, idx) => (
                                (idx<upcomingTasksQuantity) && <TasksItem key={idx} task={task} section={section} backgroundStyle={(calculateDaysBetween(today, task.deadline) <= warningDays)?'deadlineWarning':'upcoming'} />
                            ))}
                        </div>
                        <div className="overdueTasks tab-pane fade" id="overdueTasks" role="tabpanel" aria-labelledby="overdueTasksTab">
                            { overdueTasks.length === 0 && 
                                <div className='noTasks'>No Overdue Tasks</div>
                            }
                            { overdueTasks.map((task, idx) => (
                                (idx<overdueTasksQuantity) && <TasksItem key={idx} task={task} section={section} backgroundStyle={'overdue'} />
                            ))}
                        </div>
                        <div className="completedTasks tab-pane fade" id="completedTasks" role="tabpanel" aria-labelledby="completedTasksTab">
                            { completeTasks.length === 0 && 
                                <div className='noTasks'>No Complete Tasks</div>
                            }
                            { completeTasks.map((task, idx) => (
                                (idx<completeTasksQuantity) && <TasksItem key={idx} task={task} section={section} backgroundStyle={'complete'} />
                            ))}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  )
}
